import licenseModule from '../../license.module';

export default licenseModule.component('licenseNewServerPerpetual', {
    template: require('./licenseNewServerPerpetual.component.html'),
    controller: ['entitlementConstants', licenseNewServerPerpetualComponent],
    bindings: {
        summaryDeviceIdTotal: '<',
        summaryPremiumUserIdTotal: '<',
        summaryDeviceIdUsage: '<',
        summaryPremiumUserIdUsage: '<',
        licenseMaxUsers: '<',
        licenseMaxDevices: '<',
        onlyPerpetual: '<',
        callback: '&'
    }
});

function licenseNewServerPerpetualComponent(entitlementConstants) {
    var vm = this;
    vm.devicesLabel = entitlementConstants.devices;
    vm.platformUsersLabel = entitlementConstants.platformUsers;
    vm.platformUserLabel = entitlementConstants.platformUser;

    vm.$onInit = function() {
        vm.licenseMaxDevices = 0;
        vm.licenseMaxUsers = 0;
        vm.min = 1;
    };
    vm.changes = function() {
        var value = {
            license: {
                maxUsers: vm.licenseMaxUsers,
                maxDevices: vm.licenseMaxDevices
            },
            eula: vm.eula
        };
        vm.callback({ value: value });
    };
}



// WEBPACK FOOTER //
// ./modules/license/features/license-new-server-perpetual/licenseNewServerPerpetual.component.js